export default function () {
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            errorMessage: '@',
            onCancel: '=onCancel',
            cancelText: '@',
            onRetry: '=onRetry',
            retryText: '@'
        },
        link: (scope, elem, attrs) => {
            const scopE = scope;
            scopE.hasCancelFunction = () => {
                return angular.isDefined(attrs.onCancel);
            };
            scopE.hasRetryFunction = () => {
                return angular.isDefined(attrs.onRetry);
            };
        },
        template: `<div class="progress-container">
                            <div class="progress-animation text-center">
                                <img src="https://64.media.tumblr.com/avatar_1660af6dff50_128.pnj" alt="logo" width="70" height="70"
                                            style="margin-bottom: 12px;" />
                            </div>

                            <div class="progress-text text-center"
                                <span>{{errorMessage}}</span>
                            </div>

                            <br>

                            <div class="progress-cancel-action text-center" ng-if="hasRetryFunction()">
                                <button class="mdc-button mdc-button--raised" ng-click="onRetry()">
                                    <span class="mdc-button__label">{{retryText}}</span>
                                </button>
                            </div>

                            <div class="progress-cancel-action text-center" ng-if="hasCancelFunction()">
                                <a class="cancel-action-button" href="javascript:void(0);" ng-click="onCancel()">{{cancelText}}</a>
                            </div>

                        </div>`
    }
}